import { Box, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AvailableOrgList } from '../../../redux/slices/entityInstanceSlice'

interface ProgramSelectorProps {
    selectedProgramId: string
    onProgramChange: (programId: string) => void
    availableOrgList: AvailableOrgList[]
}

const ProgramSelector: React.FC<ProgramSelectorProps> = ({
    selectedProgramId,
    onProgramChange,
    availableOrgList,
}) => {
    const { t } = useTranslation()

    return (
        <Box sx={{ mb: 2 }}>
            <Typography
                variant="body1"
                sx={{
                    mb: 1,
                    color: '#666',
                    fontWeight: 500,
                }}
            >
                {t('program')}
            </Typography>
            <Select
                id="program-select"
                value={selectedProgramId}
                onChange={(e) => onProgramChange(e.target.value as string)}
                variant="outlined"
                size="small"
                fullWidth
                displayEmpty
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 30 * 12 + 8,
                        },
                    },
                }}
                sx={{
                    color: '#333',
                    '.MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ccc',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#999',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#00858f',
                    },
                }}
                renderValue={(selected) =>
                    selected ? (
                        availableOrgList.find((org) => org.id === selected)
                            ?.name
                    ) : (
                        <Typography sx={{ color: '#9ca3af' }}>
                            {t('program')}
                        </Typography>
                    )
                }
            >
                <MenuItem value="">
                    <Typography variant="body1" sx={{ fontSize: 14 }}>
                        {t('selectPlaceholder')}
                    </Typography>
                </MenuItem>
                {availableOrgList.map((org) => (
                    <MenuItem key={org.id} value={org.id}>
                        {org.name}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    )
}

export default ProgramSelector
